import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";

import Navbar from '../../EndUser/EU-Navbar.jsx';
import EUBookingCard from '../../EndUser/EUBookingCard';
import EUBookingPullout from '../../EndUser/EUBookingPullout';

import { LoadingIcon } from '../../Common/Loading_Icon';
import EmptyState from '../../Common/EmptyState';

import { setList, openPullout } from '../../../Actions/endUserActions';
import { constants } from '../../../Helpers/Constants.js';
import ModalRoutes from '../ModalRoutes.jsx';
import { Trans } from 'react-i18next';

class EUBookings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            current_tab: "current",
            current_bookings: null,
            upcoming_bookings: null,
            pending_bookings: null,
            rejected_bookings: null,
            past_bookings: null,
            cancelled_bookings: null
        };
    }

    componentDidMount() {
        var self = this;

        if (this.props.match.params.tab !== "" && (this.props.match.params.tab === "current" || this.props.match.params.tab === "upcoming" || this.props.match.params.tab === "pending" || this.props.match.params.tab === "rejected" || this.props.match.params.tab === "past" || this.props.match.params.tab === "cancelled")) {
            this.setTab(this.props.match.params.tab)
        }
                
        if (this.props.match.params.tab === "info") {
            axios.get('/ajax/booking/' + this.props.match.params.book_id)
            .then(function(response) {
                var booking = response?.data.booking

                self.props.dispatch(openPullout(booking))
                if (booking.Book_Status >= constants.booking_status.pending_oem && booking.Book_Status <= constants.booking_status.pending_both) {
                    self.setTab("pending")
                } else if (booking.Book_Status === constants.booking_status.denied) {
                    self.setTab("rejected")
                } else if (booking.Book_Status === constants.booking_status.cancelled) {
                    self.setTab("cancelled")
                } else {
                    if (moment(booking.Start_Date, "YYYY-MM-DD").isSameOrBefore(moment()) && (booking.Released_On === null || booking.Returned_On === null) || (moment(booking.Start_Date, "YYYY-MM-DD").isAfter(moment()) && booking.Released_On !== null && booking.Returned_On === null)) {
                        self.setTab("current")
                    } else if (booking.Released_On !== null && booking.Returned_On !== null) {
                        self.setTab("past")
                    } else {
                        self.setTab("upcoming")
                    }
                }
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                    self.props.history.push("/bookings/")
                    self.setTab("current")
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }

        document.title = "Bookings - FleetXPress";
    }

    setTab(tab_name) {
        var self = this;
        if (tab_name !== this.props.match.params.tab && this.props.match.params.tab !== "info") {
            this.props.history.push("/bookings/" + tab_name)
        }

        if (tab_name === "current") {
            axios.get('/ajax/mybookings/current')
            .then(function(response) {
                self.props.dispatch(setList("SET_CURRENT_BOOKINGS_LIST", response?.data.bookings.current))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else if (tab_name === "upcoming") {
            axios.get('/ajax/mybookings/upcomming')
            .then(function(response) {
                self.props.dispatch(setList("SET_UPCOMING_BOOKINGS_LIST", response?.data.bookings.upcomming))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else if (tab_name === "pending") {
            axios.get('/ajax/mybookings/pending')
            .then(function(response) {
                self.props.dispatch(setList("SET_PENDING_BOOKINGS_LIST", response?.data.bookings.pending))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else if (tab_name === "rejected") {
            axios.get('/ajax/mybookings/rejected')
            .then(function(response) {
                self.setState({
                    rejected_bookings: response?.data.bookings.denied
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else if (tab_name === "past") {
            axios.get('/ajax/mybookings/past')
            .then(function(response) {
                self.setState({
                    past_bookings: response?.data.bookings.past
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else if (tab_name === "cancelled") {
            axios.get('/ajax/mybookings/cancelled')
            .then(function(response) {
                self.setState({
                    cancelled_bookings: response?.data.bookings.cancelled
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }

        this.setState({
            current_tab: tab_name
        })
    }

    renderTab() {
        if (this.state.current_tab === "current") {
            if (! this.props.endUser.current_bookings) {
                return (<LoadingIcon />)
            } else if (this.props.endUser.current_bookings.length > 0) {
                var bookings = []

                this.props.endUser.current_bookings.map((booking) => {
                    bookings.push(<EUBookingCard booking={booking} img = {'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + booking.vehicle.Photos} year = {booking.vehicle.Year} make = {booking.vehicle.Make} model = { booking.vehicle.Model} trim = {booking.vehicle.Trim} pickupdate = {moment(booking.Start_Date + " " + booking.Release_Time).format("MMM DD, YYYY")} dropoffdate = {moment(booking.End_Date + " " + booking.Return_Time).format("MMM DD, YYYY")}/>)
                })

                return (
                    <div className="eu-bookingcard-container">
                        {bookings}
                    </div>)
                    
            } else {
                return(
                    <EmptyState image = "Calendar_Inactive.svg" text = "No Current Bookings"/>
                )
            }
        } else if (this.state.current_tab === "upcoming") {
            if (! this.props.endUser.upcoming_bookings) {
                return (<LoadingIcon />)
            } else if (this.props.endUser.upcoming_bookings.length > 0) {
                var bookings = []
                
                this.props.endUser.upcoming_bookings.map((booking) => {
                    bookings.push(<EUBookingCard booking={booking} img = {'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + booking.vehicle.Photos} year = {booking.vehicle.Year} make = {booking.vehicle.Make} model = { booking.vehicle.Model} trim = {booking.vehicle.Trim} pickupdate = {moment(booking.Start_Date + " " + booking.Release_Time).format("MMM DD, YYYY")} dropoffdate = {moment(booking.End_Date + " " + booking.Return_Time).format("MMM DD, YYYY")}/>)
                })

                return (
                    <div className="eu-bookingcard-container">
                        {bookings}
                    </div>)
            } else {
                return(
                    <EmptyState image = "Calendar_Inactive.svg" text = "No Upcoming Bookings"/>
                )
            }
        } else if (this.state.current_tab === "pending") {
            if (! this.props.endUser.pending_bookings) {
                return (<LoadingIcon />)
            } else if (this.props.endUser.pending_bookings.length > 0) {
                var bookings = []
                
                this.props.endUser.pending_bookings.map((booking) => {
                    bookings.push(<EUBookingCard booking={booking} img = {'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + booking.vehicle.Photos} year = {booking.vehicle.Year} make = {booking.vehicle.Make} model = { booking.vehicle.Model} trim = {booking.vehicle.Trim} pickupdate = {moment(booking.Start_Date + " " + booking.Release_Time).format("MMM DD, YYYY")} dropoffdate = {moment(booking.End_Date + " " + booking.Return_Time).format("MMM DD, YYYY")}/>)
                })

                return (
                    <div className="eu-bookingcard-container">
                        {bookings}
                    </div>)
            } else {
                return(
                    <EmptyState image = "Calendar_Inactive.svg" text = "No Pending Bookings"/>
                )
            }
        } else if (this.state.current_tab === "rejected") {
            if (! this.state.rejected_bookings) {
                return (<LoadingIcon />)
            } else if (this.state.rejected_bookings.length > 0) {
                var bookings = []
                
                this.state.rejected_bookings.map((booking) => {
                    bookings.push(<EUBookingCard booking={booking} img = {'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + booking.vehicle.Photos} year = {booking.vehicle.Year} make = {booking.vehicle.Make} model = { booking.vehicle.Model} trim = {booking.vehicle.Trim} pickupdate = {moment(booking.Start_Date + " " + booking.Release_Time).format("MMM DD, YYYY")} dropoffdate = {moment(booking.End_Date + " " + booking.Return_Time).format("MMM DD, YYYY")}/>)
                })

                return (
                    <div className="eu-bookingcard-container">
                        {bookings}
                    </div>)
            } else {
                return(
                    <EmptyState image = "Calendar_Inactive.svg" text = "No Rejected Bookings"/>
                )
            }
        } else if (this.state.current_tab === "past") {
            if (! this.state.past_bookings) {
                return (<LoadingIcon />)
            } else if (this.state.past_bookings.length > 0) {
                var bookings = []
                
                this.state.past_bookings.map((booking) => {
                    bookings.push(<EUBookingCard booking={booking} img = {'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + booking.vehicle.Photos} year = {booking.vehicle.Year} make = {booking.vehicle.Make} model = { booking.vehicle.Model} trim = {booking.vehicle.Trim} pickupdate = {moment(booking.Start_Date + " " + booking.Release_Time).format("MMM DD, YYYY")} dropoffdate = {moment(booking.End_Date + " " + booking.Return_Time).format("MMM DD, YYYY")}/>)
                })

                return (
                    <div className="eu-bookingcard-container">
                        {bookings}
                    </div>)
            } else {
                return(
                    <EmptyState image = "Calendar_Inactive.svg" text = "No Past Bookings"/>
                )
            }
        } else if (this.state.current_tab === "cancelled") {
            if (! this.state.cancelled_bookings) {
                return (<LoadingIcon />)
            } else if (this.state.cancelled_bookings.length > 0) {
                var bookings = []
                
                this.state.cancelled_bookings.map((booking) => {
                    bookings.push(<EUBookingCard booking={booking} img = {'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + booking.vehicle.Photos} year = {booking.vehicle.Year} make = {booking.vehicle.Make} model = { booking.vehicle.Model} trim = {booking.vehicle.Trim} pickupdate = {moment(booking.Start_Date + " " + booking.Release_Time).format("MMM DD, YYYY")} dropoffdate = {moment(booking.End_Date + " " + booking.Return_Time).format("MMM DD, YYYY")}/>)
                })

                return (
                    <div className="eu-bookingcard-container">
                        {bookings}
                    </div>)
            } else {
                return(
                    <EmptyState image = "Calendar_Inactive.svg" text = "No Cancelled Bookings"/>
                )
            }
        }
    }

    render() {
        return (
            <div>
                <Navbar history={this.props.history} match={this.props.match} location={this.props.location}/>
                <div className = "eu-bookings eu-container">
                    <div className = "eu-bookings-top bkg-primary-light">
                        <div className = "eu-bookings-wrapper pl-24 pr-24">
                            <h1 className = "white pt-16 pb-16"><Trans>Bookings</Trans></h1>
                            <ul className = "tabs white bkg-primary-light no-border no-padding" data-deep-link="true" data-deep-link-smudge="500" data-tabs id = "booking-tabs">
                                <li className={"tabs-title" + (this.state.current_tab === "current" ? " is-active" : "")} onClick={() => this.setTab("current")}>
                                    <a aria-selected={(this.state.current_tab === "current" ? "true" : "false")}>
                                        <Trans>Current</Trans>
                                    </a>
                                </li>
                                <li className={"tabs-title" + (this.state.current_tab === "upcoming" ? " is-active" : "")} onClick={() => this.setTab("upcoming")}>
                                    <a aria-selected={(this.state.current_tab === "upcoming" ? "true" : "false")}>
                                        <Trans>Upcoming</Trans>
                                    </a>
                                </li>
                                <li className={"tabs-title" + (this.state.current_tab === "pending" ? " is-active" : "")} onClick={() => this.setTab("pending")}>
                                    <a aria-selected={(this.state.current_tab === "pending" ? "true" : "false")}>
                                        <Trans>Pending</Trans>
                                    </a>
                                </li>
                                <li className={"tabs-title" + (this.state.current_tab === "rejected" ? " is-active" : "")} onClick={() => this.setTab("rejected")}>
                                    <a aria-selected={(this.state.current_tab === "rejected" ? "true" : "false")}>
                                        <Trans>Rejected</Trans>
                                    </a>
                                </li>
                                <li className={"tabs-title" + (this.state.current_tab === "past" ? " is-active" : "")} onClick={() => this.setTab("past")}>
                                    <a aria-selected={(this.state.current_tab === "past" ? "true" : "false")}>
                                        <Trans>Past</Trans>
                                    </a>
                                </li>
                                <li className={"tabs-title" + (this.state.current_tab === "cancelled" ? " is-active" : "")} onClick={() => this.setTab("cancelled")}>
                                    <a aria-selected={(this.state.current_tab === "cancelled" ? "true" : "false")}>
                                        <Trans>Cancelled</Trans>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className = "tabs-content bkg-white-dark no-border" data-tabs-content="booking-tabs">
                        {
                        this.state.loading_main ? 
                            <LoadingIcon />
                        :
                            this.renderTab()
                      }
                    </div>
                </div>
                <EUBookingPullout history={this.props.history} match={this.props.match} location={this.props.location}/>
                <ModalRoutes match={this.props.match} history={this.props.history}/>
            </div>  
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser
})

export default connect(mapStateToProps)(EUBookings)